/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/&star;/web/route.tsx', { eager: true })
 *
 * Convention `ModuleRoute` : { path, label, icon, element }.
 * On expose `element` via `lazy()` pour code-split la page principale.
 */
import { lazy, Suspense, type ReactNode } from 'react';

const CommandeTisanesPage = lazy(() => import('./pages/CommandeTisanes'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement du module Commande tisanes…
    </div>
  );
}

const route = {
  path: 'commande-tisanes',
  label: 'Commande matière première', // renommé Ben 22/08 (ex-« Commande tisanes »)
  icon: 'leaf',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <CommandeTisanesPage />
    </Suspense>
  ),
};

export default route;
